import React from "react";
import { Footer, Navbar } from "../components";

const PrivacyPage = () => {
  return (
    <>
      <Navbar />
      <div className="container my-5 py-4">
        <h1 className="text-center" data-aos="fade-up">
          Politica de privacidad
        </h1>
        <hr />
        <p data-aos="fade-up" data-aos-delay="100">
          Somos https://a1cursosmaster.com/
        </p>
        <p>
          Cursos Premium A1 informa a los usuarios del sitio web sobre su
          politica respecto del tratamiento y proteccion de los datos de
          caracter personal de los usuarios y clientes que puedan ser recabados
          por la navegacion o contratacion de servicios a traves de su sitio web.
        </p>
        <p>
          El uso de esta web implica la aceptacion de esta politica de
          privacidad. Esta Politica de Privacidad describe como se recopila,
          utiliza y comparte tu informacion personal cuando visitas o realizas
          una compra en https://a1cursosmaster.com/.
        </p>

        <h2 className="mt-4">Que informacion personal recopilamos</h2>
        <p>
          Cuando visitas el sitio web, recopilamos automaticamente cierta
          informacion sobre tu dispositivo, incluida informacion sobre tu
          navegador web, direccion IP, zona horaria y algunas de las cookies que
          estan instaladas en tu dispositivo.
        </p>
        <p>
          Ademas, a medida que navegas por el sitio web, recopilamos informacion
          sobre las paginas web individuales o los productos que ves, que sitios
          web o terminos de busqueda te remiten al sitio web, e informacion sobre
          como interactuas con el sitio web. Nos referimos a esta informacion
          recopilada automaticamente como Informacion del Dispositivo (device
          information).
        </p>
        <p>Recopilamos informacion del dispositivo utilizando las siguientes tecnologias:</p>
        <ul>
          <li>Cookies: archivos de datos que se colocan en tu dispositivo y con frecuencia incluyen un identificador unico anonimo.</li>
          <li>Archivos de registro: rastrean las acciones que ocurren en el sitio web y recopilan datos, incluida tu direccion IP, el tipo de navegador, el proveedor de servicios de Internet, las paginas de referencia/salida y las marcas de fecha y hora.</li>
        </ul>
        <p>
          La finalidad del tratamiento de los datos recabados contempla: la
          atencion de solicitudes realizadas por los usuarios, la inclusion en
          la agenda de contactos, la gestion de la relacion comercial y otras
          finalidades.
        </p>
        <p>
          Ademas, cuando efectuas una compra o intentas realizar una compra a
          traves del sitio web, recopilamos cierta informacion tuya, como tu
          nombre completo, DNI, direccion de envio mas una referencia,
          informacion de pago (incluidos numeros de tarjetas de credito o
          debito), direccion de email y el numero de telefono. Esto se denomina
          Informacion del Pedido.
        </p>
        <p>
          Metodos de pago aceptados: transferencia bancaria, billetera virtual
          y otros medios. Para mas informacion, contactanos por WhatsApp.
        </p>
        <p>
          Metodos de pago aceptados: transferencia bancaria, billetera virtual
          y otros medios. Para mas informacion, contactanos por WhatsApp.
        </p>
        <p>
          Al referirnos a Informacion Personal en esta Politica de Privacidad,
          estamos hablando tanto de la Informacion del Dispositivo como de la
          Informacion del Pedido.
        </p>

        <h2 className="mt-4">Como usamos tu informacion personal</h2>
        <p>
          Utilizamos la Informacion de Pedido que recopilamos por lo general
          para cumplir con los pedidos realizados a traves del sitio web
          (incluido el procesamiento de tu informacion de pago, la organizacion
          del envio y el envio de facturas y/o confirmaciones de pedidos).
        </p>
        <p>
          Ademas, usamos esta Informacion del Pedido para comunicarnos contigo,
          examinar nuestros pedidos para detectar posibles riesgos o fraudes y,
          en linea con las preferencias que has compartido con nosotros,
          ofrecerte informacion o publicidad relacionada con nuestros productos.
        </p>
        <p>
          Utilizamos la Informacion del Dispositivo que recopilamos para
          ayudarnos a detectar posibles riesgos y fraudes (en particular, tu
          direccion IP) y, en general, para mejorar y optimizar nuestro sitio.
        </p>

        <h2 className="mt-4">Compartiendo tu informacion personal</h2>
        <p>
          Compartimos tu Informacion Personal con terceros para ayudarnos a
          utilizarla como se describio anteriormente.
        </p>
        <p>
          Tambien empleamos Google Analytics para ayudarnos a comprender como
          nuestros clientes usan https://a1cursosmaster.com/.
        </p>
        <p>
          Finalmente, tambien podemos compartir tu Informacion Personal para
          cumplir con las leyes y regulaciones aplicables, base de datos, una
          orden de registro u otras solicitudes legales de informacion que
          recibimos, o para proteger nuestros derechos.
        </p>

        <h2 className="mt-4">Publicidad de comportamiento</h2>
        <p>
          Utilizamos tu Informacion Personal para proporcionarte anuncios
          especificos o comunicaciones de marketing que creemos que pueden ser
          de tu interes.
        </p>
        <p>Enlaces opt-out de servicios externos, tales como:</p>
        <ul>
          <li>WhatsApp</li>
          <li>Facebook</li>
          <li>Instagram</li>
          <li>Google</li>
          <li>MailChimp</li>
        </ul>
      </div>
      <Footer />
    </>
  );
};

export default PrivacyPage;
